export default __webpack_public_path__ + "static/media/cs.f6a2c0c9.png";